
import { MainLayout } from "@/components/MainLayout";
import { Dashboard } from "@/components/Dashboard";
import { SEO } from "@/components/SEO";

export default function DashboardPage() {
  return (
    <MainLayout>
      <SEO 
        title="Dashboard"
        description="Visão geral das suas finanças com gráficos interativos, resumo de receitas e despesas, e insights inteligentes para melhor controle financeiro."
        keywords="dashboard financeiro, visão geral finanças, gráficos financeiros, resumo receitas despesas"
      />
      <Dashboard />
    </MainLayout>
  );
}
